/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type markerpinEventByRefs$ref: FragmentReference;
declare export opaque type markerpinEventByRefs$fragmentType: markerpinEventByRefs$ref;
export type markerpinEventByRefs = {|
  +results: ?$ReadOnlyArray<?{|
    +ref: string,
    +title: ?string,
    +dataByCategory: ?{|
      +price: ?{|
        +amount_excl_tax: ?number
      |}
    |},
    +pictures: ?$ReadOnlyArray<?{|
      +nameId: ?string,
      +extension: ?string,
      +predictName: ?string,
    |}>,
    +urlSpacefr: ?string,
    +urlSpaceen: ?string,
    +urlSpacees: ?string,
  |}>,
  +$refType: markerpinEventByRefs$ref,
|};
export type markerpinEventByRefs$data = markerpinEventByRefs;
export type markerpinEventByRefs$key = {
  +$data?: markerpinEventByRefs$data,
  +$fragmentRefs: markerpinEventByRefs$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "refs"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "markerpinEventByRefs",
  "selections": [
    {
      "alias": "results",
      "args": [
        {
          "kind": "Variable",
          "name": "refs",
          "variableName": "refs"
        }
      ],
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "spaceGetByRefs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ref",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "category",
              "value": "production"
            }
          ],
          "concreteType": "DataByCategory",
          "kind": "LinkedField",
          "name": "dataByCategory",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Price",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "amount_excl_tax",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "dataByCategory(category:\"production\")"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "count",
              "value": 3
            }
          ],
          "concreteType": "SpacePicture",
          "kind": "LinkedField",
          "name": "pictures",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nameId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "extension",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "predictName",
              "storageKey": null
            }
          ],
          "storageKey": "pictures(count:3)"
        },
        {
          "alias": "urlSpacefr",
          "args": [
            {
              "kind": "Literal",
              "name": "lang",
              "value": "fr"
            }
          ],
          "kind": "ScalarField",
          "name": "urlByLang",
          "storageKey": "urlByLang(lang:\"fr\")"
        },
        {
          "alias": "urlSpaceen",
          "args": [
            {
              "kind": "Literal",
              "name": "lang",
              "value": "en"
            }
          ],
          "kind": "ScalarField",
          "name": "urlByLang",
          "storageKey": "urlByLang(lang:\"en\")"
        },
        {
          "alias": "urlSpacees",
          "args": [
            {
              "kind": "Literal",
              "name": "lang",
              "value": "es"
            }
          ],
          "kind": "ScalarField",
          "name": "urlByLang",
          "storageKey": "urlByLang(lang:\"es\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'b6bb1448b23ffab0b1f89c994dc71e30';

module.exports = node;
